
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { UserRound } from "lucide-react";
import { useStudentAuthDialog } from "./hooks/useStudentAuthDialog";
import { StudentLoginForm } from "./auth/StudentLoginForm";
import { StudentRegisterForm } from "./auth/StudentRegisterForm";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslations } from "@/hooks/useTranslations";

interface StudentAuthDialogProps {
  profile: any;
}

export const StudentAuthDialog = ({ profile }: StudentAuthDialogProps) => {
  const { 
    isSubmitting, 
    isLogin, 
    formData, 
    setFormData, 
    handleLogin, 
    handleSignup, 
    toggleForm 
  } = useStudentAuthDialog();
  const isMobile = useIsMobile();
  const { t } = useTranslations("publicProfile");

  const handleFormChange = (key: string, value: string | boolean) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="default" className="w-full">
          <UserRound className="mr-2 h-4 w-4" />
          {t("studentArea")}
        </Button>
      </DialogTrigger>
      <DialogContent className={`${isMobile ? 'w-[90%] max-w-[350px]' : 'sm:max-w-md'}`}>
        <DialogHeader className="space-y-4">
          <div className="flex justify-center">
            <img 
              src="/lovable-uploads/e79feb48-6e7c-488a-8626-bb79f4bde67a.png" 
              alt="Logo" 
              className="h-16 w-auto"
            />
          </div>
          <DialogTitle>
            {isLogin ? t("studentLogin") : t("studentRegister")}
          </DialogTitle>
          <DialogDescription>
            {isLogin 
              ? t("enterStudentArea")
              : t("createStudentAccount")
            }
          </DialogDescription>
        </DialogHeader>
        
        {isLogin ? (
          <StudentLoginForm 
            formData={formData}
            isSubmitting={isSubmitting}
            onFormChange={handleFormChange}
            onSubmit={handleLogin}
            onToggleForm={toggleForm}
          />
        ) : (
          <StudentRegisterForm 
            formData={formData}
            isSubmitting={isSubmitting}
            onFormChange={handleFormChange}
            onSubmit={handleSignup}
            onToggleForm={toggleForm}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
